// extracted by mini-css-extract-plugin
module.exports = {"field":"MicroForm_field__1x4wl","fieldButton":"MicroForm_fieldButton__3QGtU","row":"MicroForm_row__4LRTQ","controls":"MicroForm_controls__1zhLs","button":"MicroForm_button__3VUsT"};